import { Controller as StimulusController } from '@hotwired/stimulus'

/**
 * Stimulus controller for the turbo drawer component. This must be attached to the sl-drawer shoelace component.
 */
export default class TurboDrawerController extends StimulusController {
  connect() {
    super.connect()
    this.onLoad()
  }

  onLoad() {
    if (!this.element.open) {
      // To get opening animations, invoke the open method later in the JS event cycle
      setTimeout(() => { this.open() }, 1)
    }

    this.requireExplicitClose()
  }

  open() {
    this.element.show()
  }

  close() {
    this.element.hide()
  }

  afterHide() {
    // Clear the contents of the turbo-frame when the modal is hidden
    this.element.parentNode.replaceChildren()
  }

  requireExplicitClose(){
    /**
     * Prevent the drawer from being closed when ESC is pressed, or when the user clicks on the
     * overlay while the drawer is dirty
     */
    this.element.addEventListener('sl-request-close', (event) => {
      const escKeyPressed = event.detail.source === 'keyboard'
      const overlayClicked = event.detail.source === 'overlay'
      const drawerDirty = this.element.querySelector('[data-dirty="true"]')

      if (escKeyPressed || (overlayClicked && drawerDirty)) {
        event.preventDefault()
      }
    })
  }
}
